import { render, staticRenderFns } from "./PlacementsEndComponentReviewManager.vue?vue&type=template&id=dcd22964&"
import script from "./PlacementsEndComponentReviewManager.vue?vue&type=script&lang=js&"
export * from "./PlacementsEndComponentReviewManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports